document.addEventListener('DOMContentLoaded', function() {

    let isSwedishDomain = window.location.hostname.toLowerCase().endsWith('.se');
    let noRecommendationText = isSwedishDomain ? 'Ingen rekommendation' : 'Ingen anbefaling';

    function updateFormInputs() {
                
        let targetContainer = document.querySelector('.customer-send-formula-dimensionering-container .hidden-dynamical-inputs');
        if (!targetContainer) {
            console.warn('Target container for dynamic inputs not found');
            return;
        }
        targetContainer.innerHTML = '';

        // Find all units in custom-input-selector-group
        let unitElements = document.querySelectorAll('#custom-input-selector-group .custom-dropdown-selected');
        unitElements.forEach(function(unitElem) {
            let label = unitElem.textContent.trim();
            let matchId = unitElem.getAttribute('data-selected-id');
            let valueList =  document.querySelectorAll('.custom-inputs-list .custom-input-item.active input');
            let value;
            valueList.forEach(function(valueElem) {
                if (valueElem.id === matchId) {
                    value = valueElem.value;
                }
            });
            let input = document.createElement('input');
            input.type = 'text';
            input.name = `contact[${label}]`;
            input.value = value;
            input.className = 'input is-floating';
            targetContainer.appendChild(input);
        });


        // Find all inputs in .custom-contact-form .fieldset
        let allInputs = document.querySelectorAll('.custom-contact-form .fieldset input');
        let excludeInputs = document.querySelectorAll('.custom-inputs-list .custom-input-item input');
        allInputs.forEach(function(input) {
            let shouldExclude = false;
            excludeInputs.forEach(function(exclude) {
                if (input === exclude) {
                    shouldExclude = true;
                }
            });
            if (!shouldExclude) {
                let clone = input.cloneNode(true);
                // Transfer value for number inputs
                if (input.type === 'number') {
                    clone.value = input.value;
                } else {
                    clone.value = '';
                }
                targetContainer.appendChild(clone);
            }
        });

        // Find all selects in .custom-contact-form .fieldset
        let sourceSelects = document.querySelectorAll('.custom-contact-form .fieldset select');
        sourceSelects.forEach(function(select) {
            // Create input element
            let input = document.createElement('input');
            input.type = 'text';
            input.name = select.name;
            input.className = select.className;
            input.setAttribute('data-original-select', 'true');
            // Set value to selected option
            input.value = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '';
            targetContainer.appendChild(input);
        });
        // Add inputs for each output-row
        let outputRows = document.querySelectorAll('.output-container .output-row');
        outputRows.forEach(function(row) {
            let labelElem = row.querySelector('.output-label');
            let valueElem = row.querySelector('.output-value');
            if (labelElem && valueElem) {
                let input = document.createElement('input');
                input.type = 'text';
                input.name = `contact[${labelElem.textContent.trim()}]`;
                input.value = valueElem.textContent.trim();
                input.className = 'input is-floating';
                targetContainer.appendChild(input);
            }
        });
        let productResultTitle = document.querySelector('.custom-form-section-label .h4').textContent.trim();
        let productResult = document.querySelector('.product-recommendation-group .chosen .product-card__title')?.textContent.trim();
        if (!productResult) {
            productResult = noRecommendationText;
        }
        let input = document.createElement('input');
        input.type = 'text';
        input.name = `contact[${productResultTitle}]`;
        input.value = productResult;
        input.className = 'input is-floating';
        targetContainer.appendChild(input);
    }

    let opener = document.querySelector('.custom-send-formula-button');
    opener.addEventListener('click', function(event) {
        event.stopPropagation();
        let formContainer = document.querySelector('.customer-send-formula-dimensionering');
        if (formContainer) {
            formContainer.classList.add('active');
            updateFormInputs();
        }
    });
    let closer = document.querySelector('.customer-send-formula-dimensionering-container .modal-close');
    if (closer) {
        closer.addEventListener('click', function() {
            let formContainer = document.querySelector('.customer-send-formula-dimensionering');
            if (formContainer) {
                formContainer.classList.remove('active');
            }
        });
    }
    // Click outside handler
    document.addEventListener('click', function(event) {
        let formContainer = document.querySelector('.customer-send-formula-dimensionering');
        if (formContainer && formContainer.classList.contains('active')) {
            // Check if click is outside the container
            let container = formContainer.querySelector('.customer-send-formula-dimensionering-container');
            if (!container.contains(event.target)) {
                formContainer.classList.remove('active');
            }
        }
    });
    // Prevent click inside container from closing
    let formContainer = document.querySelector('.customer-send-formula-dimensionering');
    if (formContainer) {
        let container = formContainer.querySelector('.customer-send-formula-dimensionering-container');
        if (container) {
            container.addEventListener('click', function(event) {
                event.stopPropagation();
            });
        }
    }
    
});